/** @file keyFrameDrag: a world-space gesture turned into the frame of the dragged node's key. */
import type { Quat } from '@zilo/pose3d-math/quat/quat';
import { quatRotateVec3 } from '@zilo/pose3d-math/quat/quatRotateVec3';
import type { TransformSpace } from '../../state/editorTypes';
import { GIZMO_AXES } from './gizmoAxes';
import { quatConjugate } from './quatConjugate';
import type { KeyDrag, WorldDrag } from './viewportDrag';

/**
 * `rotate`: `local` uses the handle's own axis in the node frame (`GIZMO_AXES[axis]`), `world` the world axis taken
 * into the parent frame; `move`: the world offset in the parent frame; `scale` unchanged. `parentQ` from
 * `parentRotation`; `axis` is the handle index (null for free moves).
 */
export function keyFrameDrag(drag: WorldDrag, space: TransformSpace, axis: 0 | 1 | 2 | null, parentQ: Quat): KeyDrag {
  const inv = quatConjugate(parentQ);
  switch (drag.kind) {
    case 'rotate':
      return { kind: 'rotate', deltaDeg: drag.deltaDeg, axis: space === 'local' && axis !== null ? GIZMO_AXES[axis] : quatRotateVec3(inv, drag.axis) };
    case 'move':
      return { kind: 'move', delta: quatRotateVec3(inv, drag.delta) };
    case 'scale':
      return drag;
  }
}
